import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Radio extends Component {
    render() {
        return(
            <div className={`input__radio ${this.props.selected ? ' input__radio--selected' : ''} ${this.props.className ? this.props.className : ''}`}>
                <div className="input__radio__input">
                    <input
                        id={"radio"+this.props.id}
                        type="radio"
                        name={this.props.name}
                        value={this.props.value}
                        checked={this.props.checked}
                        onChange={this.onChange}
                        disabled={this.props.disabled === true}
                    />
                </div>
                <label
                    htmlFor={"radio"+this.props.id}
                    className="input__radio__label"
                >
                    {this.props.label}
                </label>
                {this.props.detail &&
                    <div className="input__radio__detail">
                        {this.props.detail}
                    </div>
                }
            </div>
        )
    }

    onChange = (e) => {
        this.props.onChange(e.currentTarget.value);
    }
}

Radio.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.any.isRequired,
    checked: PropTypes.bool.isRequired,
    selected: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    detail: PropTypes.any,
    disabled: PropTypes.bool,
}


export default Radio;
